export const getCoteDeBeauneData = () => ({
  name: "Côte de Beaune",
  region: "Bourgogne",
  country: "France",
  description: "La Côte de Beaune est la région de transition entre vins rouges et blancs de Bourgogne, célèbre pour ses Grands Crus blancs et ses vins rouges élégants.",
  type: "subregion",
  area: "2,000 ha",
  production: "100,000 hectolitres",
  mapAreas: [
    { region: "Côte de Beaune", x: 54, y: 60, color: "#4B164C", size: 5 }
  ],
  characteristics: {
    climate: "Climat continental tempéré, hivers froids, étés chauds",
    soil: "Sols argilo-calcaires, marnes, calcaires",
    viticulture: "Viticulture traditionnelle, rendements limités, vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges élégants et fruités, avec des notes de fruits rouges et d'épices douces",
    white: "Vins blancs complexes et riches, avec des notes de beurre et de fruits secs"
  },
  history: "La Côte de Beaune produit des vins depuis l'époque romaine. Les moines cisterciens ont développé la viticulture au Moyen Âge. La région est célèbre pour ses Grands Crus blancs.",
  foodPairing: "Viandes rouges, volailles, poissons, fromages affinés",
  grapeVarieties: [
    {
      name: "Chardonnay",
      percentage: "60%",
      description: "Cépage principal de la Côte de Beaune, produisant des vins blancs complexes et riches",
      characteristics: "Complexe, riche, notes de beurre et de fruits secs",
      wineStyles: "Sec, plein-corps, complexe"
    },
    {
      name: "Pinot Noir",
      percentage: "40%",
      description: "Cépage rouge de la Côte de Beaune, produisant des vins élégants et fruités",
      characteristics: "Élégant, fruité, tanins soyeux, notes de fruits rouges",
      wineStyles: "Sec, moyen-corps, fruité"
    }
  ]
}); 